import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_38cf49bc from 'nuxt_plugin_plugin_38cf49bc' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_985c9e08 from 'nuxt_plugin_sentryserver_985c9e08' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_4e183f74 from 'nuxt_plugin_sentryclient_4e183f74' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_4520a938 from 'nuxt_plugin_axios_4520a938' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_20d65c03 from 'nuxt_plugin_pluginutils_20d65c03' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_0aa016e4 from 'nuxt_plugin_pluginrouting_0aa016e4' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_c6ec1cbe from 'nuxt_plugin_pluginmain_c6ec1cbe' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_42d0d8e0 from 'nuxt_plugin_cookieuniversalnuxt_42d0d8e0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_logpluginserver_edbe968e from 'nuxt_plugin_logpluginserver_edbe968e' // Source: ../plugins/log.plugin.server.js (mode: 'server')
import nuxt_plugin_globalisationpluginserver_52159416 from 'nuxt_plugin_globalisationpluginserver_52159416' // Source: ../plugins/globalisation.plugin.server.js (mode: 'server')
import nuxt_plugin_configurationpluginserver_445fa1c7 from 'nuxt_plugin_configurationpluginserver_445fa1c7' // Source: ../plugins/configuration.plugin.server.js (mode: 'server')
import nuxt_plugin_justLogplugin_938c3510 from 'nuxt_plugin_justLogplugin_938c3510' // Source: ../plugins/justLog.plugin.js (mode: 'all')
import nuxt_plugin_statisticsplugin_15e5d962 from 'nuxt_plugin_statisticsplugin_15e5d962' // Source: ../plugins/statistics.plugin.js (mode: 'all')
import nuxt_plugin_httpplugin_650d40f4 from 'nuxt_plugin_httpplugin_650d40f4' // Source: ../plugins/http.plugin.js (mode: 'all')
import nuxt_plugin_footerContentpluginserver_25161d42 from 'nuxt_plugin_footerContentpluginserver_25161d42' // Source: ../plugins/footerContent.plugin.server.js (mode: 'server')
import nuxt_plugin_logpluginclient_23674331 from 'nuxt_plugin_logpluginclient_23674331' // Source: ../plugins/log.plugin.client.js (mode: 'client')
import nuxt_plugin_clientNavigationTimerpluginclient_fed0ea22 from 'nuxt_plugin_clientNavigationTimerpluginclient_fed0ea22' // Source: ../plugins/clientNavigationTimer.plugin.client.js (mode: 'client')
import nuxt_plugin_gtmplugin_3cb6cae0 from 'nuxt_plugin_gtmplugin_3cb6cae0' // Source: ../plugins/gtm.plugin.js (mode: 'all')
import nuxt_plugin_featureManagementpluginserver_6056da44 from 'nuxt_plugin_featureManagementpluginserver_6056da44' // Source: ../plugins/featureManagement.plugin.server.js (mode: 'server')
import nuxt_plugin_featureManagementpluginclient_0ac52e88 from 'nuxt_plugin_featureManagementpluginclient_0ac52e88' // Source: ../plugins/featureManagement.plugin.client.js (mode: 'client')
import nuxt_plugin_clientIdentificationpluginserver_1378e950 from 'nuxt_plugin_clientIdentificationpluginserver_1378e950' // Source: ../plugins/clientIdentification.plugin.server.js (mode: 'server')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"vmid":"preload-just-eat-basis-font","rel":"preload","type":"font\u002Fwoff2","href":"https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-Regular-optimised.woff2","as":"font","crossorigin":"anonymous"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[{"vmid":"font-styles","cssText":"@font-face {\n                        font-family: JETSansDigital;\n                        src: url('https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-Regular-optimised.woff2') format('woff2'),\n                        url('https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-Regular-optimised.woff') format('woff');\n                        font-weight: 400;\n                        font-display: swap;\n                    }\n                    body {\n                        font-feature-settings: 'tnum';\n                    }","once":true}],"script":[{"vmid":"load-fonts","innerHTML":"(function loadFontScript() {\n  const boldFontUrls = 'url(\"https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-Bold-optimised.woff2\") format(\"woff2\"), url(\"https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-Bold-optimised.woff\") format(\"woff\")';\n  const extraboldFontUrls = 'url(\"https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-ExtraBold-optimised.woff2\") format(\"woff2\"), url(\"https:\u002F\u002Fd30v2pzvrfyzpo.cloudfront.net\u002Ffonts\u002FJETSansDigital-ExtraBold-optimised.woff\") format(\"woff\")';\n\n  const bold = new FontFace('JETSansDigital', boldFontUrls, { weight: '700' });\n  const extrabold = new FontFace('JETSansDigital', extraboldFontUrls, { weight: '800' });\n\n  Promise.all([bold.load(), extrabold.load()]).\n  then((fonts) =\u003E {\n    fonts.forEach((font) =\u003E {\n      document.fonts.add(font);\n    });\n  }).\n  then(() =\u003E {\n    document.documentElement.classList.add('webfonts-loaded');\n  });\n})();","body":true,"once":true}],"__dangerouslyDisableSanitizers":["style","script"]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_38cf49bc === 'function') {
    await nuxt_plugin_plugin_38cf49bc(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_985c9e08 === 'function') {
    await nuxt_plugin_sentryserver_985c9e08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_4e183f74 === 'function') {
    await nuxt_plugin_sentryclient_4e183f74(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4520a938 === 'function') {
    await nuxt_plugin_axios_4520a938(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_20d65c03 === 'function') {
    await nuxt_plugin_pluginutils_20d65c03(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_0aa016e4 === 'function') {
    await nuxt_plugin_pluginrouting_0aa016e4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_c6ec1cbe === 'function') {
    await nuxt_plugin_pluginmain_c6ec1cbe(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_42d0d8e0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_42d0d8e0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_logpluginserver_edbe968e === 'function') {
    await nuxt_plugin_logpluginserver_edbe968e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_globalisationpluginserver_52159416 === 'function') {
    await nuxt_plugin_globalisationpluginserver_52159416(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_configurationpluginserver_445fa1c7 === 'function') {
    await nuxt_plugin_configurationpluginserver_445fa1c7(app.context, inject)
  }

  if (typeof nuxt_plugin_justLogplugin_938c3510 === 'function') {
    await nuxt_plugin_justLogplugin_938c3510(app.context, inject)
  }

  if (typeof nuxt_plugin_statisticsplugin_15e5d962 === 'function') {
    await nuxt_plugin_statisticsplugin_15e5d962(app.context, inject)
  }

  if (typeof nuxt_plugin_httpplugin_650d40f4 === 'function') {
    await nuxt_plugin_httpplugin_650d40f4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_footerContentpluginserver_25161d42 === 'function') {
    await nuxt_plugin_footerContentpluginserver_25161d42(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_logpluginclient_23674331 === 'function') {
    await nuxt_plugin_logpluginclient_23674331(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientNavigationTimerpluginclient_fed0ea22 === 'function') {
    await nuxt_plugin_clientNavigationTimerpluginclient_fed0ea22(app.context, inject)
  }

  if (typeof nuxt_plugin_gtmplugin_3cb6cae0 === 'function') {
    await nuxt_plugin_gtmplugin_3cb6cae0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_featureManagementpluginserver_6056da44 === 'function') {
    await nuxt_plugin_featureManagementpluginserver_6056da44(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_featureManagementpluginclient_0ac52e88 === 'function') {
    await nuxt_plugin_featureManagementpluginclient_0ac52e88(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_clientIdentificationpluginserver_1378e950 === 'function') {
    await nuxt_plugin_clientIdentificationpluginserver_1378e950(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
